import React, { useState, useEffect } from 'react';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { useSelector } from 'react-redux';
import methodModel from '../../methods/methods';
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import Layout from '../../components/global/layout';
import SelectDropdown from '../../components/common/SelectDropdown';
import statusModel from '../../models/status.model';
import { Tooltip } from 'antd';
import ImageUpload from '../../components/common/ImageUpload';
import MultiSelectDropdown from '../../components/common/MultiSelectDropdown';

const AddEdit = () => {
  const { id } = useParams();
  const [images, setImages] = useState({ image: '' });
  const [num, setnum] = useState(1);
  const [data, setdata] = useState([]);
  const [SeachQuery] = useSearchParams();
  let template_id = SeachQuery.get('template_id');
  let course_id = SeachQuery.get('course_id');

  const [form, setform] = useState({
    course_id: '',
    certificate_template_id: '',
  });

  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const user = useSelector((state) => state.user);
  const formValidation = [{ key: 'course_id', required: true }];
  const [Courses, setCourses] = useState([]);
  const [features, setFeatures] = useState(['']);
  const [tab, setTab] = useState('');
  const [Templates, setTemplates] = useState([]);
  const [dataget, dataset] = useState([]);
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!form?.course_id || !form?.certificate_template_id) {
      return false;
    }
    // let invalid = methodModel.getFormError(formValidation, form);
    // if (invalid) return;
    let method = 'post';
    let url = 'certificate';
    let value = {
      ...form,
    };
    if (id) {
      method = 'put';
      url = 'certificate';
      value = {
        course_id: form?.course_id,
        id: JSON.parse(id),
        certificate_template_id: form?.certificate_template_id,
        name: form?.name,
      };
    } else {
      value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        // ToastsStore.success(res.message)
        history('/certificate');
      }
      loader(false);
    });
  };

  const GetCourses = () => {
    ApiClient.get('course/all', { status: 'active', isDeleted: false }).then(
      (res) => {
        if (res.success) {
          let array = [];
          res?.data?.map((itm) => {
            array.push({ id: itm?.id, name: itm?.title });
          });
          console.log(array, '===========DATA');
          setCourses(array);

          dataset(array.map((itm) => itm.name));
        }
      }
    );
  };
  const GetTemplates = () => {
    ApiClient.get('certificateTemplate/all', {
      status: 'active',
      isDeleted: false,
    }).then((res) => {
      if (res.success) {
        let array = [];
        res?.data?.map((itm) => {
          array.push({ id: itm?.id, name: itm?.title });
        });
        setTemplates(array);
      }
    });
  };

  useEffect(() => {
    GetCourses();
    GetTemplates();
    if (id) {
      loader(true);
      ApiClient.get('certificate', { id }).then((res) => {
        if (res.success) {
          let value = res.data;
          setFeatures(res?.data?.options);
          setform({
            ...form,
            course_id: res?.data?.course_id?.id,
            id: id,
            name: res?.data?.name,
            certificate_template_id: res?.data?.certificate_template_id?.id,
          });
          if (res?.data?.certificate_template_id?.id) {
            setTab('exist');
          }
        }
        loader(false);
      });
    }
  }, [id]);

  const imageResult = (e, key) => {
    images[key] = e.value;
    setImages(images);
  };

  const updatetag = (index, key, value) => {
    let arr = features;
    arr[index] = value;
    console.log(arr, key, value, index);
    setFeatures([...arr]);
    setform({
      ...form,
      options: [...arr],
    });
    console.log(form);
    setnum(arr.length);
  };

  const removetag = (index) => {
    setFeatures([...features.filter((itm, i) => i != index)]);
    setform({
      ...form,
      options: [...features.filter((itm, i) => i != index)],
    });

    setnum(num - 1);
  };

  const AddTag = () => {
    features.push(' ');
    setFeatures([...features]);
  };

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link
                  to="/certificate"
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all  mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? 'Edit' : 'Add'} Certificate
                </h3>
                <p class="text-sm font-normal text-[#525252]">
                  Here you can see all about your Certificate
                </p>
              </div>
            </div>

            <h5 className="text-[#A12238] mb-2">
              <b>Template</b>
              <span className="star">*</span>
            </h5>

            <ul class="flex flex-wrap text-sm font-medium text-center text-gray-500 dark:text-gray-400 mb-3">
              <li class="me-2">
                <a
                  class={`${
                    tab == 'exist'
                      ? '!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed active'
                      : 'inline-block h-10 border border-[1px] px-4 flex items-center rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white active'
                  }`}
                  aria-current="page"
                  onClick={() => {
                    setTab('exist');
                  }}
                >
                  Existing Template
                </a>
              </li>

              <li class="me-2">
                <a
                  onClick={() => {
                    history(
                      `/template/add?certificate=true&course_id=${form?.course_id}`
                    );
                  }}
                  class={`${
                    tab == 'new'
                      ? '!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed active'
                      : 'inline-block h-10 border border-[1px] px-4 flex items-center rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white active'
                  }`}
                >
                  Create New
                </a>
              </li>
            </ul>
            {submitted && !form.certificate_template_id ? (
              <div className="text-danger">Template is Required</div>
            ) : (
              <></>
            )}

            <div className="border_div border-b-[1px] border-dashed border-[#A12238] mt-5 mb-5"></div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6 md:col-span-6">
                <label>
                  Name<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form.name}
                  onChange={(e) => {
                    const fetchdata = e.target.value;
                    setform({ ...form, name: fetchdata });
                  }}
                  // required
                />
                {submitted && !form.name ? (
                  <div className="invalid-feedback d-block">
                    Name is Required
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-span-6 md:col-span-6">
                <label>
                  Course<span className="star">*</span>
                </label>
                <div className="custom_dropdown">
                  <SelectDropdown
                    id="statusDropdown"
                    displayValue="name"
                    placeholder="Select Course"
                    intialValue={form.course_id}
                    result={(e) => {
                      setform({ ...form, course_id: e.value });
                    }}
                    options={Courses}
                  />
                  {/* {submitted && !form.course_id ? (
                    <div className="text-danger">Course is Required</div>
                  ) : (
                    <></>
                  )} */}

                  {submitted && !form.name ? (
                    <div className="invalid-feedback d-block">
                      Course is Required
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {tab == 'exist' ? (
                <div className="col-span-6 md:col-span-6">
                  <label>
                    Template<span className="star">*</span>
                  </label>
                  <div className="custom_dropdown">
                    <SelectDropdown
                      id="statusDropdown"
                      displayValue="name"
                      placeholder="Select Template"
                      intialValue={form.certificate_template_id}
                      result={(e) => {
                        if (e.value == 'new_template') {
                          return history(
                            `/template/add?certificate=true&course_id=${form?.course_id}`
                          );
                        }
                        setform({ ...form, certificate_template_id: e.value });
                      }}
                      options={Templates}
                    />
                    {submitted && !form.certificate_template_id ? (
                      <div className="text-danger">Template is Required</div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="text-right mt-3">
              <button
                type="submit"
                className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEdit;
